
<template>
  <div class="calendar-weeks">
    <v-layout row wrap>
      <v-flex xs12>
        <v-layout row wrap class="calendar-header elevation-2 mb-1 pa-0">
          <v-flex xs2 class="py-1">
            <h3>UNIDADE - SALA</h3>
          </v-flex>
          <v-layout row wrap class="ma-0">
            <v-flex xs2 class="py-1" :class="{'holiday': date.holiday}" v-for="(date, ind) in calendar" :key="ind">
              <!-- <h3 class="text-xs-center">{{ date.day | convertDate }}</h3> -->
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <h3 v-on="on" class="text-xs-center">{{ date.day | convertDate }}</h3>
                </template>
                <span v-if="date.holiday">{{ date.holiday.name }} - {{ date.holiday.date | convertDate }}</span>
                <span v-else>-</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-layout row wrap v-for="(room, ind) in calendar[0].rooms" :key="ind" class="calendar-body elevation-2 mb-1">
          <v-flex xs2 class="py-1">
            <h3>{{ room.unit_code }} - {{ room.name }}</h3>
          </v-flex>
          <v-layout row wrap class="ma-0">
            <v-flex class="py-1" xs2 v-for="(week, ind2) in calendar" :key="ind2" :class="{'calendar-interactive': interactive}">
              <h3 v-if="week.rooms[ind].classroom != null" @click="goClass(week.rooms[ind].classroom.class_id)" class="text-xs-center">{{ week.rooms[ind].classroom.course_code }}{{ week.rooms[ind].unit_code }}{{ week.rooms[ind].classroom.class_code }} <span class="first-module" v-if="week.rooms[ind].classroom.position == 'first'"><i class="fas fa-asterisk"></i></span> <span class="last-module" v-if="week.rooms[ind].classroom.position == 'last'"><i class="fas fa-graduation-cap"></i></span></h3>
              <h3 v-else class="text-xs-center">-</h3>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>

    <div class="calendar-controls">
      <i class="fas fa-backward" @click="backCalendar()"></i>
      <i class="fas fa-calendar" @click="todayCalendar()"></i>
      <i class="fas fa-search" @click="showPickerCalendar()"></i>
      <i class="fas fa-forward" @click="nextCalendar()"></i>
    </div>

    <v-dialog v-model="changeCalendar" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>ALTERAR DATA BASE DO CALENDARIO.</v-card-title>
        <v-card-text>
          <v-date-picker v-model="pickerChangeDate" :full-width="true" :no-title="true" first-day-of-week="1" :allowed-dates="compAllow" locale="pt-BR"></v-date-picker>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="changeCalendar = false">SAIR</v-btn>
          <v-btn color="primary" flat @click="changeCalendar = false; changeToDate();">PROSSEGUIR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import moment from 'moment'

export default {
  props: ['start', 'interactive', 'comp-allow'],
  data() {
    return {
      baseDate: moment().day(5).format('YYYY-MM-DD'),
      calendar: null,
      pickerChangeDate: '',
      changeCalendar: false,
      loadingCalendar: true,
      holidays: [],
    }
  },
  methods: {
    getCalendar() {
      this.$http.get(`calendar/base/${this.baseDate}`).then(data => {
        this.calendar = data.data
        this.loadingCalendar = false
      }).catch(err => {
        
      })
    },
    todayCalendar() {
      this.baseDate = moment().day(5).format('YYYY-MM-DD')
      this.getCalendar()
    },
    nextCalendar() {
      this.baseDate = moment(this.baseDate).add(1, 'week').format('YYYY-MM-DD')
      if (!this.loadingCalendar) { this.getCalendar() }
    },
    backCalendar() {
      this.baseDate = moment(this.baseDate).subtract(1, 'week').format('YYYY-MM-DD')
      if (!this.loadingCalendar) { this.getCalendar() }
    },
    showPickerCalendar() {
      this.changeCalendar = true
    },
    changeToDate() {
      this.baseDate = this.pickerChangeDate
      this.getCalendar()
    },
    goClass(id) {
      if (this.interactive) {
        this.$router.push({name: 'classPos', params: { id }})
      }
    },
    getHolidays(year) {
      this.$http.get(`https://api.calendario.com.br/?json=true&token=a2FycmVpcmFAbWlvbG9jYXQuY29tJmhhc2g9MTAxNjA4MDc0&ano=${year}&estado=SP&cidade=Sao_Paulo`).then(async data => {
        data.data.forEach(holidayObj => {
          const dateSplited = holidayObj.date.split('/')
          this.holidays.push({ day: `${dateSplited[2]}-${dateSplited[1]}-${dateSplited[0]}`, name: holidayObj.name })
        })
      }).catch(err => {

      })
    }
  },
  watch: {
    start(newDate, oldDate) {
      this.baseDate = moment(moment(newDate).format('YYYY-MM')).day(5).format('YYYY-MM-DD')
      this.getCalendar()
    },
    async calendar(newCalendar, oldCalendar) {
      if (oldCalendar == null) {
        await this.getHolidays(moment.utc().format('YYYY'))
      } else if (moment.utc(newCalendar[4].day).format('YYYY') != moment.utc(oldCalendar[4].day).format('YYYY')) {
        await this.getHolidays(moment.utc(newCalendar[4].day).format('YYYY'))
      }
      this.calendar.forEach((calendar, calendarIndex) => {
        this.holidays.find((holiday, holidayIndex) => {
          if (holiday.day == calendar.day || holiday.day == moment.utc(calendar.day).subtract(1, 'days').format('YYYY-MM-DD') || holiday.day == moment.utc(calendar.day).add(1, 'days').format('YYYY-MM-DD') || holiday.day == moment.utc(calendar.day).add(2, 'days').format('YYYY-MM-DD') || holiday.day == moment.utc(calendar.day).add(3, 'days').format('YYYY-MM-DD')) {
            // console.log(holiday, holidayIndex)
            this.calendar[calendarIndex].holiday = {
              name: holiday.name,
              date: holiday.day
            }
          }
        })
      })
    }
  },
  created() {
    this.getCalendar()
  }
}
</script>

<style scoped>
  .calendar-controls {
    position: fixed;
    top: 8px;
    right: 26px;
    z-index: 100;
  }
  .calendar-controls i {
    color: #fff;
    margin-left: 10px;
    font-size: 1.4em;
    border: 2px solid #fff;
    padding: 6px;
  }
  .calendar-controls i:hover {
    cursor: pointer;
    color: #000;
    background-color: #fff;
  }
  .calendar-controls i:first-child {
    border-top-left-radius: 20%;
    border-bottom-left-radius: 20%;
  }
  .calendar-controls i:last-child {
    border-top-right-radius: 20%;
    border-bottom-right-radius: 20%;
  }
  .calendar-header {
    background-color: #fff;
  }
  .calendar-body {
    background-color: #fff;
  }
  .calendar-interactive:hover {
    cursor: pointer;
    color: #fff;
    background-color: rgb(196, 22, 28);
  }
  .first-module {
    color: #2196F3;
  }
  .last-module {
    color: #E65100;
  }
  .holiday {
    background-color: #FFEE58;
  }
</style>
